export { default } from './StaticPageList';
